import { common } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import PageNotFound from "./404-page";
import useFlag from "./hooks/useFlag";
import { FLAGS } from "./utils/Constant/FlagConstant";
import "./App.css";
import { DataLayer } from "./DataLayer/DataLayer";
import ProtectedRoute from "./DataLayer/ProtectedRoute";
import reducer, { initialState } from "./DataLayer/reducer";
import AddBlog from "./Pages/AddBlog/AddBlog";
import AddVlog from "./Pages/AddVlog/AddVlog";
import Vlogs from "./Pages/WebPages/Vlogs";
import PopupList from "./Pages/Homepage/Popup";
import CreatePopup from "./Pages/Homepage/Popup/CreatePopup";
import EditPopup from "./Pages/Homepage/Popup/EditPopup";
import SeoMetaTagList from "./Pages/Homepage/SeoMetaTag";
import CreateSeoMetaTag from "./Pages/Homepage/SeoMetaTag/CreateSeoMetaTag";
import EditSeoMetaTag from "./Pages/Homepage/SeoMetaTag/EditSeoMetaTag";

import Booking from "./Pages/Bookings/CabinBookings";
import EditBookings from "./Pages/Bookings/CabinBookings/EditBooking";
import Leads from "./Pages/Bookings/Leads";
import EditLeads from "./Pages/Bookings/Leads/EditLeads";
import MemberBooking from "./Pages/Bookings/MemberCabinBookings";
import EditMemberBooking from "./Pages/Bookings/MemberCabinBookings/EditMemberBooking";
import ChangePassword from "./Pages/ChangePassword";
import Dashboard from "./Pages/Dashboard";
import ForgetPassword from "./Pages/ForgetPassword";
import Ancillary from "./Pages/Homepage/Ancillary";
import CreateAncillary from "./Pages/Homepage/Ancillary/CreateAncillary";
import EditAncillary from "./Pages/Homepage/Ancillary/EditAncillary";
import Announcement from "./Pages/Homepage/Announcement";
import CreateAnnouncement from "./Pages/Homepage/Announcement/CreateAnnouncement";
import EditAnnouncement from "./Pages/Homepage/Announcement/EditAnnouncement";
import Banner from "./Pages/Homepage/Banner/Banner";
import CreateBanner from "./Pages/Homepage/Banner/CreateBanner";
import EditBanner from "./Pages/Homepage/Banner/EditBanner";
import BestPrice from "./Pages/Homepage/BestPrice";
import CrisisData from "./Pages/Homepage/CrisisData";
import CreateCrisisData from "./Pages/Homepage/CrisisData/CreateCrisisData";
import EditCrisisData from "./Pages/Homepage/CrisisData/EditCrisisData";
import CrisisPopup from "./Pages/Homepage/CrisisPopup";
import CreateCrisisPopup from "./Pages/Homepage/CrisisPopup/CreateCrisisPopup";
import EditCrisisPopup from "./Pages/Homepage/CrisisPopup/EditCrisisPopup";
import DailyPlannerData from "./Pages/Homepage/DailyPlanner";
import CreateDailyPlanner from "./Pages/Homepage/DailyPlanner/CreateDailyPlanner";
import EditDailyPlanner from "./Pages/Homepage/DailyPlanner/EditDailyPlanner";
import EditDuplicateDailyPlaneer from "./Pages/Homepage/DailyPlanner/EditDuplicateDailyPlaneer";
import DealDetails from "./Pages/Homepage/DealDetails";
import CreateDealDetails from "./Pages/Homepage/DealDetails/CreateDealDetails";
import EditDealDetails from "./Pages/Homepage/DealDetails/EditDealDetails";
import CreateDeal from "./Pages/Homepage/Deals/CreateDeal";
import EditDeal from "./Pages/Homepage/Deals/EditDeal";
import CreateDestination from "./Pages/Homepage/Destination/CreateDestination";
import Destination from "./Pages/Homepage/Destination/Destinations";
import EditDestination from "./Pages/Homepage/Destination/EditDestination";
import Menubar from "./Pages/Menubar/Menubar";
import CreateMenubar from "./Pages/Menubar/CreateMenubar";
import EditMenubar from "./Pages/Menubar/EditMenubar";
import MenubarMenuItems from "./Pages/Menubar/MenuItems/MenubarMenuItems";
import CreateMenubarMenuItem from "./Pages/Menubar/MenuItems/CreateMenubarMenuItem";
import EditMenubarMenuItem from "./Pages/Menubar/MenuItems/EditMenubarMenuItem";
import Experience from "./Pages/Homepage/Experience";
import CreateExperience from "./Pages/Homepage/Experience/CreateExperience";
import EditExperience from "./Pages/Homepage/Experience/EditExperience";
import NewsLetter from "./Pages/Homepage/NewsLetter";
import EditNewsLetter from "./Pages/Homepage/NewsLetter/EditNewsLetter";
import SailingDateData from "./Pages/Homepage/SailingDate";
import CreateSailingPageData from "./Pages/Homepage/SailingDate/CreateSailingPageData";
import EditDuplicateSailingPages from "./Pages/Homepage/SailingDate/EditDuplicateSailingPages";
import EditSailingPages from "./Pages/Homepage/SailingDate/EditSailingPages";
import WebPageTeamplate from "./Pages/Homepage/WebPageTeamplate";
import CreateWebpageTeamplate from "./Pages/Homepage/WebPageTeamplate/CreateWebPageTeamplate";
import CreateLocation from "./Pages/Location/CreateLocation";
import EditLocation from "./Pages/Location/EditLocation";
import Location from "./Pages/Location/Location";
import Login from "./Pages/Login";
import APILogs from "./Pages/Logs/APILogs";
import LoylteeLogs from "./Pages/Logs/LoylteeLogs";
import UserLogs from "./Pages/Logs/UserLogs";
import CardType from "./Pages/Loyltee/CardType";
import CreateCardType from "./Pages/Loyltee/CardType/CreateCardType";
import EditCardType from "./Pages/Loyltee/CardType/EditCardType";
import Currency from "./Pages/Loyltee/Currency";
import CreateCurrency from "./Pages/Loyltee/Currency/CreateCurrency";
import EditCurreny from "./Pages/Loyltee/Currency/EditCurrency";
import DRSInstance from "./Pages/Loyltee/DRSInstance";
import CreateDRSInstance from "./Pages/Loyltee/DRSInstance/CreateDrsInstance";
import EditDrsInstance from "./Pages/Loyltee/DRSInstance/EditDrsInstance";
import CabinCategory from "./Pages/Master/CabinCategory";
import CreateCabinCategory from "./Pages/Master/CabinCategory/CreateCabinCategory";
import EditCabinCategory from "./Pages/Master/CabinCategory/EditCabinCategory";
import CabinMaster from "./Pages/Master/CabinModule";
import CreateCabinMaster from "./Pages/Master/CabinModule/CreateCabinMaster";
import EditCabinMaster from "./Pages/Master/CabinModule/EditCabinMaster";
import CabinTypes from "./Pages/Master/CabinTypes";
import {
  default as CreateCabinType,
  default as CreateNewsLetter,
} from "./Pages/Master/CabinTypes/CreateCabinType";
import EditCabinType from "./Pages/Master/CabinTypes/EditCabinType";
import FareCode from "./Pages/Master/FareCode";
import CreateFareCode from "./Pages/Master/FareCode/CreateFareCode";
import EditFareCode from "./Pages/Master/FareCode/EditFareCode";
import ActivityCategoryMaster from "./Pages/Mobile/ActivityCategory";
import CreateActivityMaster from "./Pages/Mobile/ActivityCategory/CreateActivityMaster";
import EditActivityMaster from "./Pages/Mobile/ActivityCategory/EditCreateActivityMaster";
import VenueMaster from "./Pages/Mobile/VenueMaster";
import CreateVenueMaster from "./Pages/Mobile/VenueMaster/CreateVenueMaster";
import EditVenueMaster from "./Pages/Mobile/VenueMaster/EditVenueMaster";
import OtherPage from "./Pages/OtherPages";
import CreateOtherPages from "./Pages/OtherPages/CreateOtherPage";
import EditOtherPage from "./Pages/OtherPages/EditOtherPage";
import EditGroupedPackages from "./Pages/Packages/EditGroupedPackages";
import Packages from "./Pages/Packages/Packages";
import MyProfile from "./Pages/Profile/MyProfile";
import Permission from "./Pages/Profile/Permisson";
import Roles from "./Pages/Profile/Role";
import EditRole from "./Pages/Profile/Role/EditRole";
import UserManagment from "./Pages/Profile/UserMangment";
import EditUser from "./Pages/Profile/UserMangment/EditUser";
import Promos from "./Pages/PromoIndex/PromoIndex";
import Register from "./Pages/Register";
import ResetPassword from "./Pages/ResetPassword";
import CreateSailingDate from "./Pages/SailingDate/CreateSailingDate";
import EditSailingDate from "./Pages/SailingDate/EditSailingDate";
import SailingDate from "./Pages/SailingDate/SailingDate";
import AgeValidation from "./Pages/AgeValidation/AgeValidation";
import CreateAgeValidation from "./Pages/AgeValidation/CreateAgeValidation";
import EditAgeValidation from "./Pages/AgeValidation/EditAgeValidation";
import SpecialPages from "./Pages/SpecialPages";
import CreateSpecialPages from "./Pages/SpecialPages/CreateSpecialPage";
import EditSpecialPage from "./Pages/SpecialPages/EditSpecialPage";
import BalconyClassMain from "./Pages/WebPages/AboutUs/BalconyClassMain";
import OurStoryPage from "./Pages/WebPages/AboutUs/OurStory";
import FaqPage from "./Pages/WebPages/AboutUs/SafetyGuidsPage";
import SafetyGuidsPages from "./Pages/WebPages/AboutUs/SafetyGuidsPages";
import { default as ThePalacePage } from "./Pages/WebPages/AboutUs/ThePalace";
import HomePage from "./Pages/WebPages/AboutUs/home";
import Blogs from "./Pages/WebPages/Blogs";
import LoginPageList from "./Pages/WebPages/LoginPage"
import BrochuresGuides from "./Pages/WebPages/BrochuresGuides";
import ContactUs from "./Pages/WebPages/Contact";
import DealsPage from "./Pages/WebPages/Deals";
import AddDealsPage from "./Pages/WebPages/Deals/AddDealsPage";
import Promotions from "./Pages/WebPages/Deals/Promotions";
import WebPage from "./Pages/WebPages/Deals/WebPage";
import DestinationPage from "./Pages/WebPages/DestinationsPage";
import EditDestinationPage from "./Pages/WebPages/DestinationsPage/EditDestinationPage";
import EventsPageMain from "./Pages/WebPages/Events";
import EventsListPage from "./Pages/WebPages/EventsPage";
import AddEventsPage from "./Pages/WebPages/EventsPage/AddEventsPage";
import EditEventsPage from "./Pages/WebPages/EventsPage/EditEventsPage";
import EditEntertainmentPage from "./Pages/WebPages/Experiences/Entertainment";
import LifeatRWC from "./Pages/WebPages/Experiences/LifeatRWC";
import MICEPage from "./Pages/WebPages/Experiences/MICE";
import ExperiencePage from "./Pages/WebPages/ExperiencesPage";
import BillofRights from "./Pages/WebPages/Footer/Bill of Rights";
import Career from "./Pages/WebPages/Footer/Career";
import { Ships } from "./Pages/WebPages/Ships";
import EditShips from "./Pages/WebPages/Ships/Editships";
import KnowBeforeYouSail from "./Pages/WebPages/header/KnowBeforeYouSail";
import MediaAndResource from "./Pages/WebPages/header/MediaAndResource";
import PrepareForCruise from "./Pages/WebPages/header/PrepareForCruise";
import ChooseCustomList from "./components/mobile/CustomComponents/ChooseCustomList";
import CreateShowCustomList from "./components/mobile/CustomComponents/CreateShowCustomList";
import CreateShowCustomListShip from "./components/mobile/CustomComponents/CreateShowCustomListShip";
import EditShowCustomList from "./components/mobile/CustomComponents/EditShowCustomList";
import EditMobilePageDataShip from "./components/mobile/CustomComponents/EditShowCustomListShip";
import ShowCustomList from "./components/mobile/CustomComponents/ShowCustomList";
import ShowCustomListmobile from "./components/mobile/CustomComponents/ShowCustomListmobile";
import HomeMasterInput from "./components/mobile/Shore/HomeMasterInput";
import MobileNotificationInput from "./Pages/Mobile/Notification";
import CreateNotification from "./Pages/Mobile/Notification/CreateNotification";
import EditNotification from "./Pages/Mobile/Notification/EditNotification";
import ErrorHandler from "./constants/ErrorHandler";
import Loading from "./constants/Loading";
import "./dist/css/adminlte.min.css";
import "./global/custom.css";
import { getToken } from "./utils/Api";
import Shortcuts from "./Pages/Mobile/Shortcuts";
import CreateShortcuts from "./Pages/Mobile/Shortcuts/CreateShortcuts";
import EditShortcuts from "./Pages/Mobile/Shortcuts/EditShortcuts";
import SafetyPage from "./Pages/WebPages/Experiences/Saftery";
import AddSafety from "./Pages/AddBlog/AddSafety";
import BestPriceGuaranteePage from "./Pages/WebPages/header/BestPriceGuaranteePage";
import CashVoucher from "./Pages/WebPages/Deals/CashVouchers";
import ErrorModule from "./Pages/ErrorModule";
import EditErrorModule from "./Pages/ErrorModule/EditErrorModule";
import AncillaryPurchases from "./Pages/MobileAncillary/Purchases";
import ViewPurchase from "./Pages/MobileAncillary/Purchases/ViewPurchase";
import AncillaryErrorModule from "./Pages/MobileAncillary/ErrorModule";
import ViewError from "./Pages/MobileAncillary/ErrorModule/ViewError";
import SeawareAncillaryCMS from "./Pages/MobileAncillary/SeawareAncillaryCMS";
import ShoreExcursionsManagement from "./Pages/BackOffice/ShoreExcursions/Management";
import ShoreExcursionsReport from "./Pages/BackOffice/ShoreExcursions/Report";
import ViewShorexTransaction from "./Pages/BackOffice/ShoreExcursions/Report/ViewTransaction";
import ShorexSalesReport from "./Pages/BackOffice/ShoreExcursions/Report/Sales";
import ShorexSummaryReport from "./Pages/BackOffice/ShoreExcursions/Report/Summary";
import ShorexVoidTransaction from "./Pages/BackOffice/ShoreExcursions/VoidTransaction";
import EntertainmentManagement from "./Pages/BackOffice/Entertainment/Management";
import CreateEntertainmentRvc from "./Pages/BackOffice/Entertainment/Management/CreateEntertainmentRvc";
import EditEntertainmentRvc from "./Pages/BackOffice/Entertainment/Management/EditEntertainmentRvc";
import EntertainmentRevenueCenter from "./Pages/BackOffice/Entertainment/RevenueCenter";
import EntertainmentRevenueCenterDetail from "./Pages/BackOffice/Entertainment/RevenueCenter/Detail";
import CreateEntertainmentItemizer from "./Pages/BackOffice/Entertainment/RevenueCenter/Detail/Itemizer/CreateItemizer";
import EditEntertainmentItemizer from "./Pages/BackOffice/Entertainment/RevenueCenter/Detail/Itemizer/EditItemizer";
import CreateEntertainmentMenuItem from "./Pages/BackOffice/Entertainment/RevenueCenter/Detail/MenuItem/CreateMenuItem";
import EditEntertainmentMenuItem from "./Pages/BackOffice/Entertainment/RevenueCenter/Detail/MenuItem/EditMenuItem";
import EntertainmentSalesReport from "./Pages/BackOffice/Entertainment/Report/Sales";
import EntertainmentSummaryReport from "./Pages/BackOffice/Entertainment/Report/Summary";
import EntertainmentVoidTransaction from "./Pages/BackOffice/Entertainment/VoidTransaction";
import EntertainmentViewTransaction from "./Pages/BackOffice/Entertainment/Report/ViewTransaction";
import ItineraryPackages from "./Pages/Mobile/ItineraryPakages";
import EditItinerary from "./Pages/Mobile/ItineraryPakages/EditItinerary";
import LittleDremers from "./Pages/WebPages/Experiences/LittleDreamers";
import CreateLoginPage from "./Pages/WebPages/LoginPage/addLoginPageSlider";
import EditLoginPage from "./Pages/WebPages/LoginPage/editLoginPageSlider";

function FlagProtectedRoute({ flag, children }) {
  const { enabled, loading } = useFlag(flag);
  if (loading) return null;
  if (!enabled) return <Navigate to="/" replace />;
  return <ProtectedRoute>{children}</ProtectedRoute>;
}

function App() {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/profile/user-management/add",
      element: (
        <ProtectedRoute>
          <Register />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/user-management/edit/:id",
      element: (
        <ProtectedRoute>
          <EditUser />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/reset-password",
      element: (
        <ProtectedRoute>
          <ChangePassword />
        </ProtectedRoute>
      ),
    },
    {
      path: "/forget-password",
      element: <ForgetPassword />,
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
    },
    {
      path: "/website/masters/ancillary-details",
      element: <Ancillary />,
    },
    {
      path: "/website/masters/ancillary-details/add",
      element: <CreateAncillary />,
    },
    {
      path: "/website/masters/ancillary-details/edit/:id",
      element: <EditAncillary />,
    },
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Dashboard />{" "}
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/banner",
      element: (
        <ProtectedRoute>
          <Banner />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/announcement",
      element: (
        <ProtectedRoute>
          <Announcement />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/announcement/add",
      element: (
        <ProtectedRoute>
          <CreateAnnouncement />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/announcement/edit/:id",
      element: (
        <ProtectedRoute>
          <EditAnnouncement />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/banner/add",
      element: (
        <ProtectedRoute>
          <CreateBanner />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/banner/edit/:id",
      element: (
        <ProtectedRoute>
          <EditBanner />
        </ProtectedRoute>
      ),
    },
    // {
    //   path: "/website/cms/homepage/deals",
    //   element: (
    //     <ProtectedRoute>
    //
    //       <Deals />
    //     </ProtectedRoute>
    //   ),
    // },
    {
      path: "/website/cms/homepage/deals/add",
      element: (
        <ProtectedRoute>
          <CreateDeal />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/deals/edit/:id",
      element: (
        <ProtectedRoute>
          <EditDeal />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/destinations",
      element: (
        <ProtectedRoute>
          <Destination />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/destinations/add",
      element: (
        <ProtectedRoute>
          <CreateDestination />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/destinations/edit/:id",
      element: (
        <ProtectedRoute>
          <EditDestination />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/menubar",
      element: (
        <ProtectedRoute>
          <Menubar />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/menubar/add",
      element: (
        <ProtectedRoute>
          <CreateMenubar />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/menubar/edit/:id",
      element: (
        <ProtectedRoute>
          <EditMenubar />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/menubar/:menubarId/view",
      element: (
        <ProtectedRoute>
          <MenubarMenuItems />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/menubar/:menubarId/view/add",
      element: (
        <ProtectedRoute>
          <CreateMenubarMenuItem />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/menubar/:menubarId/view/edit/:id",
      element: (
        <ProtectedRoute>
          <EditMenubarMenuItem />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/packages",
      element: (
        <ProtectedRoute>
          <Packages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/promo-index",
      element: (
        <ProtectedRoute>
          <Promos />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/experience",
      element: (
        <ProtectedRoute>
          <Experience />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/experience/add",
      element: (
        <ProtectedRoute>
          <CreateExperience />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/experience/edit/:id",
      element: (
        <ProtectedRoute>
          <EditExperience />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/packages",
      element: (
        <ProtectedRoute>
          <Packages />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/cms/packages/edit/:id",
      element: (
        <ProtectedRoute>
          <EditGroupedPackages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/other-pages",
      element: (
        <ProtectedRoute>
          <OtherPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/other-pages/add",
      element: (
        <ProtectedRoute>
          <CreateOtherPages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/other-pages/edit/:id",
      element: (
        <ProtectedRoute>
          <EditOtherPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/special-pages",
      element: (
        <ProtectedRoute>
          <SpecialPages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/special-pages/add",
      element: (
        <ProtectedRoute>
          <CreateSpecialPages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/special-pages/edit/:id",
      element: (
        <ProtectedRoute>
          <EditSpecialPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/crisis-page/Crisis-data",
      element: (
        <ProtectedRoute>
          <CrisisData />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/crisis-page/Crisis-data/add",
      element: (
        <ProtectedRoute>
          <CreateCrisisData />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/crisis-page/Crisis-data/edit/:id",
      element: (
        <ProtectedRoute>
          <EditCrisisData />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/crisis-page/crisis-popup",
      element: (
        <ProtectedRoute>
          <CrisisPopup />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/crisis-page/crisis-popup/add",
      element: (
        <ProtectedRoute>
          <CreateCrisisPopup />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/crisis-page/crisis-popup/edit/:id",
      element: (
        <ProtectedRoute>
          <EditCrisisPopup />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/news-letter",
      element: (
        <ProtectedRoute>
          <NewsLetter />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/news-letter/add",
      element: (
        <ProtectedRoute>
          <CreateNewsLetter />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/news-letter/edit/:id",
      element: (
        <ProtectedRoute>
          <EditNewsLetter />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/deal-details",
      element: (
        <ProtectedRoute>
          <DealDetails />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/cms/homepage/deal-details/add",
      element: (
        <ProtectedRoute>
          <CreateDealDetails />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/deal-details/edit/:id",
      element: (
        <ProtectedRoute>
          <EditDealDetails />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-types",
      element: (
        <ProtectedRoute>
          <CabinTypes />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/masters/cabin-types/add",
      element: (
        <ProtectedRoute>
          <CreateCabinType />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-types/edit/:id",
      element: (
        <ProtectedRoute>
          <EditCabinType />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/card-types",
      element: (
        <ProtectedRoute>
          <CardType />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/loyalty/drs-instance",
      element: (
        <ProtectedRoute>
          <DRSInstance />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/loyalty/drs-instance/add",
      element: (
        <ProtectedRoute>
          <CreateDRSInstance />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/drs-instance/edit/:id",
      element: (
        <ProtectedRoute>
          <EditDrsInstance />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/card-types/add",
      element: (
        <ProtectedRoute>
          <CreateCardType />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/card-types/edit/:id",
      element: (
        <ProtectedRoute>
          <EditCardType />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/currency",
      element: (
        <ProtectedRoute>
          <Currency />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/loyalty/currency/add",
      element: (
        <ProtectedRoute>
          <CreateCurrency />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/currency/edit/:id",
      element: (
        <ProtectedRoute>
          <EditCurreny />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-category",
      element: (
        <ProtectedRoute>
          <CabinCategory />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-category/add",
      element: (
        <ProtectedRoute>
          <CreateCabinCategory />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-category/edit/:id",
      element: (
        <ProtectedRoute>
          <EditCabinCategory />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/markets",
      element: (
        <ProtectedRoute>
          <FareCode />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/markets/add",
      element: (
        <ProtectedRoute>
          <CreateFareCode />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/markets/edit/:id",
      element: (
        <ProtectedRoute>
          <EditFareCode />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-master",
      element: (
        <ProtectedRoute>
          <CabinMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-master/add",
      element: (
        <ProtectedRoute>
          <CreateCabinMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/masters/cabin-master/edit/:id",
      element: (
        <ProtectedRoute>
          <EditCabinMaster />
        </ProtectedRoute>
      ),
    },

    {
      path: "*",
      element: <PageNotFound />,
    },
    {
      path: "/website/cms/homepage/location",
      element: (
        <ProtectedRoute>
          <Location />
        </ProtectedRoute>
      ),
    },
    //mobile
    {
      path: "/shore/mobile-masters/activity-categories",
      element: (
        <ProtectedRoute>
          <ActivityCategoryMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/activity-categories/add",
      element: (
        <ProtectedRoute>
          <CreateActivityMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/activity-categories/edit/:id",
      element: (
        <ProtectedRoute>
          <EditActivityMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/venue",
      element: (
        <ProtectedRoute>
          <VenueMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/venue/add",
      element: (
        <ProtectedRoute>
          <CreateVenueMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/packages",
      element: (
        <ProtectedRoute>
          <ItineraryPackages />
        </ProtectedRoute>
      ),
    },
     {
      path: "/shore/mobile-masters/packages/edit/:id",
      element: (
        <ProtectedRoute>
          <EditItinerary />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/venue/edit/:id",
      element: (
        <ProtectedRoute>
          <EditVenueMaster />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/location/add",
      element: (
        <ProtectedRoute>
          <CreateLocation />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/location/:id",
      element: (
        <ProtectedRoute>
          <EditLocation />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/bookings/leads",
      element: (
        <ProtectedRoute>
          <Leads />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/bookings/leads/edit/:id",
      element: (
        <ProtectedRoute>
          <EditLeads />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/bookings/cabin-booking",
      element: (
        <ProtectedRoute>
          <Booking />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/bookings/error-module",
      element: (
        <ProtectedRoute>
          {" "}
          <ErrorModule />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/bookings/error-module/edit/:id",
      element: (
        <ProtectedRoute>
          {" "}
          <EditErrorModule />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/member-bookings",
      element: (
        <ProtectedRoute>
          <MemberBooking />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/member-bookings/edit/:id",
      element: (
        <ProtectedRoute>
          <EditMemberBooking />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/bookings/best-price",
      element: (
        <ProtectedRoute>
          <BestPrice />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/deals",
      element: (
        <ProtectedRoute>
          <DealsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/cms/homepage/home",
      element: (
        <ProtectedRoute>
          <HomePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/deals/celebration-packages",
      element: (
        <ProtectedRoute>
          <AddDealsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/deals/onboard-promotions",
      element: (
        <ProtectedRoute>
          <Promotions />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/deals/cash-vouchers",
      element: (
        <ProtectedRoute>
          <CashVoucher />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/about-us/our-story",
      element: (
        <ProtectedRoute>
          <OurStoryPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/about-us/balcony-class",
      element: (
        <ProtectedRoute>
          <BalconyClassMain />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/header/prepare-for-your-cruise",
      element: (
        <ProtectedRoute>
          <PrepareForCruise />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/about-us/brochures-guides",
      element: (
        <ProtectedRoute>
          <BrochuresGuides />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/header/know-before-you-sail",
      element: (
        <ProtectedRoute>
          <KnowBeforeYouSail />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/header/know-before-you-sail",
      element: (
        <ProtectedRoute>
          <KnowBeforeYouSail />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/header/best-price-guarantee",
      element: (
        <ProtectedRoute>
          <BestPriceGuaranteePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/privacy-policy",
      element: (
        <ProtectedRoute>
          <BillofRights router={"privacy-policy"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/bill-of-rights",
      element: (
        <ProtectedRoute>
          <BillofRights router={"bill-of-rights"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/career",
      element: (
        <ProtectedRoute>
          <Career />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/terms-of-usage",
      element: (
        <ProtectedRoute>
          <BillofRights router={"terms-of-usage"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/terms-and-conditions",
      element: (
        <ProtectedRoute>
          <BillofRights router={"terms-and-conditions"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/cookie-policy",
      element: (
        <ProtectedRoute>
          <BillofRights router={"cookie-policy"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/passage-terms",
      element: (
        <ProtectedRoute>
          <BillofRights router={"passage-terms"} />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/webpages/about-us/safety-guides",
      element: (
        <ProtectedRoute>
          <SafetyGuidsPages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/press-releases",
      element: (
        <ProtectedRoute>
          <MediaAndResource />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/footer/contact-us",
      element: (
        <ProtectedRoute>
          <ContactUs />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/about-us/faq",
      element: (
        <ProtectedRoute>
          <FaqPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/bookings/cabin-booking/edit/:id",
      element: (
        <ProtectedRoute>
          <EditBookings />
        </ProtectedRoute>
      ),
    },
    {
      path: "website/bookings/error-module",
      element: (
        <ProtectedRoute>
          {" "}
          <ErrorModule />
        </ProtectedRoute>
      ),
    },
    {
      path: "website/bookings/error-module/edit/:id",
      element: (
        <ProtectedRoute>
          {" "}
          <EditErrorModule />
        </ProtectedRoute>
      ),
    },

    {
      path: "/webpages/templates",
      element: (
        <ProtectedRoute>
          <WebPageTeamplate />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/templates/add",
      element: (
        <ProtectedRoute>
          <CreateWebpageTeamplate />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/ships",
      element: (
        <ProtectedRoute>
          <Ships />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/sailing_currency",
      element: (
        <ProtectedRoute>
          <SailingDate />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/sailing_currency/add",
      element: (
        <ProtectedRoute>
          <CreateSailingDate />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/sailing_currency/edit/:id",
      element: (
        <ProtectedRoute>
          <EditSailingDate />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/age-validation",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <AgeValidation />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/age-validation/add",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <CreateAgeValidation />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-masters/age-validation/edit/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EditAgeValidation />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/all-pages/:vessel/:cat",
      element: (
        <ProtectedRoute>
          <ShowCustomList />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/cruise-page/:vessel",
      element: (
        <ProtectedRoute>
          <SailingDateData />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/daily-planner/:vessel",
      element: (
        <ProtectedRoute>
          <DailyPlannerData />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/daily-planner/:vessel/add",
      element: (
        <ProtectedRoute>
          <CreateDailyPlanner />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/daily-planner/:vessel/duplicate/:id",
      element: (
        <ProtectedRoute>
          <EditDuplicateDailyPlaneer />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/daily-planner/:vessel/edit/:id",
      element: (
        <ProtectedRoute>
          <EditDailyPlanner />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/home-page/:vessel",
      element: (
        <ProtectedRoute>
          <HomeMasterInput />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/notifications",
      element: (
        <ProtectedRoute>
          <MobileNotificationInput />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/notifications/add",
      element: (
        <ProtectedRoute>
          <CreateNotification />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/notifications/edit/:id",
      element: (
        <ProtectedRoute>
          <EditNotification />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/cruise-page/:vessel/add",
      element: (
        <ProtectedRoute>
          <CreateSailingPageData />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/cruise-page/:vessel/duplicate/:id",
      element: (
        <ProtectedRoute>
          <EditDuplicateSailingPages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/cruise-page/:vessel/edit/:id",
      element: (
        <ProtectedRoute>
          <EditSailingPages />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/all-pages/:vessel/:cat/add",
      element: (
        <ProtectedRoute>
          <CreateShowCustomList />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/all-pages/:vessel/:cat/edit/:id",
      element: (
        <ProtectedRoute>
          <EditShowCustomList />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ship/all-pages/:vessel/:cat",
      element: (
        <ProtectedRoute>
          <ShowCustomListmobile type={"ship"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/ship-shortcuts/:vessel",
      element: (
        <ProtectedRoute>
          <Shortcuts />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/ship-shortcuts/:vessel/add",
      element: (
        <ProtectedRoute>
          <CreateShortcuts />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/ship-shortcuts/:vessel/edit/:id",
      element: (
        <ProtectedRoute>
          <EditShortcuts />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ship/all-pages/:vessel/:cat/:page-id/add",
      element: (
        <ProtectedRoute>
          <CreateShowCustomListShip type={"ship"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ship/all-pages/:vessel/:cat/add",
      element: (
        <ProtectedRoute>
          <ChooseCustomList />
        </ProtectedRoute>
      ),
    },
    {
      path: "/ship/all-pages/:vessel/:cat/edit/:id",
      element: (
        <ProtectedRoute>
          <EditMobilePageDataShip />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/ships/edit/:id",
      element: (
        <ProtectedRoute>
          <EditShips />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/ships/add",
      element: (
        <ProtectedRoute>
          <EditShips />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/destinations",
      element: (
        <ProtectedRoute>
          <DestinationPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/destinations/edit/:id",
      element: (
        <ProtectedRoute>
          <EditDestinationPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/destinations/add",
      element: (
        <ProtectedRoute>
          <EditDestinationPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiencePage",
      element: (
        <ProtectedRoute>
          <ExperiencePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/the-palace",
      element: (
        <ProtectedRoute>
          <ThePalacePage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/little-dreamers",
      element: (
        <ProtectedRoute>
          <LittleDremers />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/entertainment",
      element: (
        <ProtectedRoute>
          <EditEntertainmentPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/events",
      element: (
        <ProtectedRoute>
          <EventsListPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/events/edit/:id",
      element: (
        <ProtectedRoute>
          <EditEventsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/events/add",
      element: (
        <ProtectedRoute>
          <AddEventsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/events/events",
      element: (
        <ProtectedRoute>
          <EventsPageMain />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/blog/add",
      element: (
        <ProtectedRoute>
          <AddBlog />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/blog/edit/:id",
      element: (
        <ProtectedRoute>
          <AddBlog />
        </ProtectedRoute>
      ),
    },

    {
      path: "/website/webpages/mice",
      element: (
        <ProtectedRoute>
          <MICEPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/experiences/life-at-rwc",
      element: (
        <ProtectedRoute>
          <LifeatRWC />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/blog",
      element: (
        <ProtectedRoute>
          <Blogs />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/vlog/add",
      element: (
        <ProtectedRoute>
          <AddVlog />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/vlog/edit/:id",
      element: (
        <ProtectedRoute>
          <AddVlog />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/vlog",
      element: (
        <ProtectedRoute>
          <Vlogs />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/popup",
      element: (
        <FlagProtectedRoute flag={FLAGS.WEB_POPUP}>
          <PopupList />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/popup/add",
      element: (
        <FlagProtectedRoute flag={FLAGS.WEB_POPUP}>
          <CreatePopup />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/popup/edit/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.WEB_POPUP}>
          <EditPopup />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/seo-meta-tag",
      element: (
        <ProtectedRoute>
          <SeoMetaTagList />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/seo-meta-tag/add",
      element: (
        <ProtectedRoute>
          <CreateSeoMetaTag />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/seo-meta-tag/edit/:id",
      element: (
        <ProtectedRoute>
          <EditSeoMetaTag />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/webpages/login-page",
      element: (
        <ProtectedRoute>
          <LoginPageList/>
        </ProtectedRoute>
      ),
    },
     {
      path: "/website/webpages/login-page/add",
      element: (
        <ProtectedRoute>
          <CreateLoginPage/>
        </ProtectedRoute>
      ),
    },
     {
      path: "/website/webpages/login-page/edit/:id",
      element: (
        <ProtectedRoute>
          <EditLoginPage/>
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/my-profile",
      element: (
        <ProtectedRoute>
          <MyProfile />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/user-management",
      element: (
        <ProtectedRoute>
          <UserManagment />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/role/add",
      element: (
        <ProtectedRoute>
          <Permission />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/role/edit/:id",
      element: (
        <ProtectedRoute>
          <EditRole />
        </ProtectedRoute>
      ),
    },
    {
      path: "/template",
      element: (
        <ProtectedRoute>
          <WebPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profile/role",
      element: (
        <ProtectedRoute>
          <Roles />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/webpages/legal/mobile-bill-of-rights",
      element: (
        <ProtectedRoute>
          <BillofRights router={"mobile-bill-of-rights"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/webpages/legal/mobile-privacy-policy",
      element: (
        <ProtectedRoute>
          <BillofRights router={"mobile-privacy-policy"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/webpages/legal/mobile-cookie-policy",
      element: (
        <ProtectedRoute>
          <BillofRights router={"mobile-cookie-policy"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/webpages/legal/mobile-terms-of-usage",
      element: (
        <ProtectedRoute>
          <BillofRights router={"mobile-terms-of-usage"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/webpages/legal/mobile-safety-and-guides",
      element: (
        <ProtectedRoute>
          <AddSafety />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/webpages/legal/mobile-passage-terms",
      element: (
        <ProtectedRoute>
          <BillofRights router={"mobile-passage-terms"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/webpages/legal/mobile-terms-and-conditions",
      element: (
        <ProtectedRoute>
          <BillofRights router={"mobile-terms-and-conditions"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-ancillary/purchases",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2}>
          <AncillaryPurchases />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-ancillary/purchases/view/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2}>
          <ViewPurchase />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-ancillary/error-module",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2}>
          <AncillaryErrorModule />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-ancillary/error-module/view/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2}>
          <ViewError />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/mobile-ancillary/seaware-ancillary",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2}>
          <SeawareAncillaryCMS />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/shore-excursions/management",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD}>
          <ShoreExcursionsManagement />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/shore-excursions/report",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD}>
          <ShoreExcursionsReport />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/shore-excursions/report/view/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD}>
          <ViewShorexTransaction />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/shore-excursions/report/sales",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD}>
          <ShorexSalesReport />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/shore-excursions/report/summary",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD}>
          <ShorexSummaryReport />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/shore-excursions/void-transaction",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD}>
          <ShorexVoidTransaction />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/management",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EntertainmentManagement />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/management/add",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <CreateEntertainmentRvc />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/management/edit/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EditEntertainmentRvc />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/revenue-center",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EntertainmentRevenueCenter />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/revenue-center/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EntertainmentRevenueCenterDetail />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/revenue-center/:id/itemizer/add",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <CreateEntertainmentItemizer />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/revenue-center/:id/itemizer/edit/:itemizerId",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EditEntertainmentItemizer />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/revenue-center/:id/menu-item/add",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <CreateEntertainmentMenuItem />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/revenue-center/:id/menu-item/edit/:menuItemId",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EditEntertainmentMenuItem />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/report/sales",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EntertainmentSalesReport />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/report/summary",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EntertainmentSummaryReport />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/void-transaction",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EntertainmentVoidTransaction />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/shore/back-office/entertainment/report/view/:id",
      element: (
        <FlagProtectedRoute flag={FLAGS.APP_PHASE_2_ONBOARD_ENTERTAINMENT}>
          <EntertainmentViewTransaction />
        </FlagProtectedRoute>
      ),
    },
    {
      path: "/logs/user-logs",
      element: (
        <ProtectedRoute>
          <UserLogs />
        </ProtectedRoute>
      ),
    },
    {
      path: "/website/loyalty/loyalty-logs",
      element: (
        <ProtectedRoute>
          <LoylteeLogs />
        </ProtectedRoute>
      ),
    },
    {
      path: "logs/log-api",
      element: (
        <ProtectedRoute>
          <APILogs />
        </ProtectedRoute>
      ),
    },
  ]);

  useEffect(() => {
    getToken();
  }, []);
  const customTheme = (theme) =>
    createTheme({
      ...theme,
      palette: {
        ...theme.palette,
        primary: {
          main: common.black,
        },
      },
    });
  return (
    <HelmetProvider>
      <ThemeProvider theme={customTheme}>
        <DataLayer initialState={initialState} reducer={reducer}>
          <ErrorHandler />
          <Loading />
          <RouterProvider router={router} />
        </DataLayer>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
